<template>
  <Navbar homeviewsubpage logourl="/rental/home" />

  <section id="changeData">
    <div class="container pt-5" data-aos="fade-up">
      <div class="section-caption">
        <h2>
          <img src="../assets/editIcon.svg" alt="" />&nbsp;Zmień swoje dane
        </h2>
      </div>
      <div class="section-content">
        <div class="tile">
          <div class="row mt-3">
            <div class="col-12">
              <Alert
                alert-type="alert-info"
                alert-text="Poniżej możesz edytować wybrane dane osobowe, jakie przechowywane są w naszej bazie danych."
              />
            </div>
            <div class="input-group mb-3">
              <vue-tel-input
                v-model="phone"
                name="phone"
                :inputOptions="{
                  placeholder: 'Numer telefonu obowiązkowy',
                  required: true,
                  name: 'phone',
                  autocomplete: 'tel',
                }"
                :styleClasses="[
                  isPhoneValid(phone)
                    ? 'form-control is-valid display-flex'
                    : 'form-control is-invalid display-flex',
                ]"
              >
              </vue-tel-input>
            </div>
            <div class="input-group mb-3">
              <vue-tel-input
                v-model="mobile"
                name="mobile"
                :inputOptions="{
                  placeholder: 'Numer telefonu dodatkowy',
                  required: false,
                  name: 'cellphone',
                  autocomplete: 'mobile tel',
                }"
                :styleClasses="[
                  isPhoneValid(mobile) ||
                  mobile === null ||
                  mobile === ''
                    ? 'form-control is-valid display-flex'
                    : 'form-control is-invalid display-flex',
                ]"
              >
              </vue-tel-input>
            </div>
            <div class="col">
              <div class="form-group mb-3">
                <input
                  type="text"
                  v-model="email"
                  name="email"
                  autocomplete="email"
                  class="form-control"
                  :class="[
                    isEmailValid(email) &&
                    this.email !== null &&
                    this.email !== ''
                      ? 'is-valid'
                      : 'is-invalid',
                  ]"
                  placeholder="Podaj adres email"
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="">
              <div class="row">
                <div class="col-12">
                  <div class="input-group mb-2 d-block">
                    <div class="input-group-text text-start">
                      <label class="text-wrap"
                        ><input
                          type="checkbox"
                          v-model="agreements"
                          name="rental_agreement"
                          class="form-check-input checkbox-blue mt-1"
                          :class="[
                            !this.agreements['service']
                              ? 'is-invalid'
                              : 'is-valid',
                          ]"
                          placeholder=""
                          value="service"
                          required
                        />
                        <span style="color: red; margin-left: 0.25rem">*</span>
                        Potwierdzam, że (zgoda wymagana):
                        <ul style="padding-left: 2rem">
                          <li> zapoznałem się z regulaminem świadczenia
                            usługi "Tester na wynajem"
                            <a
                                href="/rental/regulations"
                                target="_blank"
                                class="alert-link"
                            >(czytaj tu)</a
                            >, akceptuję go i zobowiązuję się do jego przestrzegania;</li>
                          <li> wyrażam zgodę na wystawianie faktur w formie elektronicznej i wysyłanie ich na podany podczas rejestracji adres email;</li>
                          <li> wyrażam zgodę na przetwarzanie moich danych osobowych oraz na otrzymywanie korespondencji elektronicznej dotyczącej aktualizacji oprogramowania oraz abonamentu systemu diagnostycznego CDIF/3 i NEX.</li>
                        </ul>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <!--              <div class="row">-->
              <!--                <div class="col-12">-->
              <!--                  <Alert-->
              <!--                    alert-type="alert-info"-->
              <!--                    alert-text="Uwaga: zaznaczenie poniższej zgody jest konieczne, aby otrzymywać informacje m.in. o upływie okresu obowiązywania abonamentu oraz możliwości jego przedłużenia."-->
              <!--                  />-->
              <!--                </div>-->
              <!--              </div>-->
              <div class="row">
                <div class="col-12">
                  <div class="input-group mb-2 d-block">
                    <div class="input-group-text text-start">
                      <label class="text-wrap">
                        <input
                          type="checkbox"
                          name="info_agreement"
                          v-model="agreements"
                          class="form-check-input checkbox-blue mt-1"
                          placeholder=""
                          value="newsletter"
                        />
                        Zgadzam się na otrzymywanie od Axes System sp. z o.o.
                        informacji handlowych drogą elektroniczną.
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <div class="input-group mb-2 d-block">
                    <div class="input-group-text text-start">
                      <label class="text-wrap">
                        <input
                          type="checkbox"
                          name="phone_agreement"
                          v-model="agreements"
                          class="form-check-input checkbox-blue mt-1"
                          placeholder=""
                          value="phone"
                        />
                        Zgadzam się na otrzymywanie od Axes System sp. z o.o.
                        informacji handlowych drogą telefoniczną.
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <Alert
                v-if="userDataChangedAlert"
                :key="alertKey"
                alert-type="alert-success"
                alert-text="Zmiana danych użytkownika zakończona powodzeniem"
              />
              <Alert
                v-if="userDataNotChangedAlert"
                :key="alertKey"
                alert-type="alert-danger"
                alert-text="Zmiana danych użytkownika zakończona niepowodzeniem"
              />
            </div>
          </div>
          <div class="text-center">
            <button
              class="btn-standard"
              @click="onChangeDataButtonClick($event)"
            >
              Zmień
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section id="changePassword" class="mt-1">
    <div class="container" data-aos="fade-up">
      <div class="section-caption">
        <h2>
          <img src="../assets/keyIcon.svg" alt="" />&nbsp;Zmień swoje hasło
        </h2>
      </div>
      <div class="section-content">
        <div class="tile">
          <Alert
            alert-type="alert-info"
            alert-text="Tutaj możesz zmienić swoje hasło dostępu do konta."
          />
          <div class="input-group mb-4" style="height: 1.5rem">
            <input
              :type="password1Type"
              v-model.trim="oldPassword"
              name="oldPassword"
              class="form-control"
              autocomplete="current-password"
              required
              placeholder="Wpisz stare hasło"
            />
            <img
              :src="eyeImage1"
              @click="togglePassword1View"
              class="imageTogglePasswordOld"
              alt=""
            />
          </div>
          <div class="input-group mb-3" style="height: 1.5rem">
            <input
              :type="password2Type"
              v-model="newPassword"
              minlength="8"
              name="newPassword"
              autocomplete="new-password"
              @input="isPasswordValid(newPassword)"
              class="form-control"
              :class="[
                isPasswordValid(newPassword) &&
                this.newPassword !== null &&
                this.newPassword !== ''
                  ? 'is-valid'
                  : 'is-invalid',
              ]"
              placeholder="Wpisz nowe hasło"
              required
            />
            <img
              :src="eyeImage2"
              @click="togglePassword2View"
              class="imageTogglePassword"
              alt=""
            />
          </div>
          <h5 class="input-subcaption">
            Hasło musi składać się z przynajmniej 8 znaków (bez spacji)
          </h5>
          <div class="input-group mb-3" style="height: 1.5rem">
            <input
              :type="password3Type"
              v-model="newPasswordRepeat"
              minlength="8"
              name="newPasswordRepeat"
              autocomplete="new-password"
              @input="isPasswordValid(newPasswordRepeat)"
              class="form-control"
              :class="[
                isPasswordValid(newPasswordRepeat) &&
                this.newPassword === this.newPasswordRepeat
                  ? 'is-valid'
                  : 'is-invalid',
              ]"
              placeholder="Powtórz nowe hasło"
              required
            />
            <img
              :src="eyeImage3"
              @click="togglePassword3View"
              class="imageTogglePassword"
              alt=""
            />
          </div>
          <h5 class="input-subcaption">
            Hasło musi składać się z przynajmniej 8 znaków (bez spacji)
          </h5>
          <Alert
            v-if="userPasswordChangedAlert"
            :key="alertKey"
            alert-type="alert-success"
            alert-text="Zmiana hasła użytkownika zakończona powodzeniem"
          />
          <Alert
            v-if="userPasswordNotChangedAlert"
            :key="alertKey"
            alert-type="alert-danger"
            alert-text="Zmiana hasła użytkownika zakończona niepowodzeniem"
          />
          <div class="text-center">
            <button class="btn-standard m-2" @click="onBackButtonClick">
              Wstecz
            </button>
            <button
              class="btn-standard"
              @click="onChangePasswordButtonClick($event)"
            >
              Zmień
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- Stopka -->
  <Footer />
</template>

<script>
import Alert from "../components/Alert.vue";
import { RequestResult } from "@/utils/requestResult";
import {
  isEmailValid,
  isPhoneValid,
  isPasswordValid,
  makeRequest,
  scrollToTop,
} from "@/utils/helpers";
import Footer from "@/components/Footer.vue";
import Navbar from "@/components/Navbar.vue";

export default {
  name: "EditUserDataView",

  components: {
    Navbar,
    Footer,
    Alert,
  },

  computed: {
    eyeImage1() {
      return this.eyeImg1Clicked
        ? "/rental/img/eye_off.svg"
        : "/rental/img/eye_on.svg"; // UWAGA: obrazki w folderze img w repo, nie ma ich w source/src/assets bo się nie chcą dodawać do builda dynamicznie
    },
    eyeImage2() {
      return this.eyeImg2Clicked
        ? "/rental/img/eye_off.svg"
        : "/rental/img/eye_on.svg";
    },
    eyeImage3() {
      return this.eyeImg3Clicked
        ? "/rental/img/eye_off.svg"
        : "/rental/img/eye_on.svg";
    },
  },

  data() {
    return {
      email: null,
      phone: null,
      mobile: null,
      agreements: [],
      user: null,
      oldPassword: null,
      newPassword: null,

      // dodatkowe dane z formularza nie przekazywane do zapytania
      newPasswordRepeat: null,

      // do poszczególnych popupów/alertów
      userDataChangedAlert: false,
      userDataNotChangedAlert: false,
      userPasswordChangedAlert: false,
      userPasswordNotChangedAlert: false,

      password1Type: "password",
      password2Type: "password",
      password3Type: "password",
      eyeImg1Clicked: false,
      eyeImg2Clicked: false,
      eyeImg3Clicked: false,

      alertKey: 0, // do rerendera strony
    };
  },

  async mounted() {
    scrollToTop();

    await this.getUserData();
  },

  methods: {
    isEmailValid,
    isPhoneValid,
    isPasswordValid,

    /* nie da się tego lepiej zrobić?*/
    togglePassword1View() {
      if (this.password1Type === "password") this.password1Type = "text";
      else this.password1Type = "password";

      this.eyeImg1Clicked = !this.eyeImg1Clicked;
    },

    togglePassword2View() {
      if (this.password2Type === "password") this.password2Type = "text";
      else this.password2Type = "password";

      this.eyeImg2Clicked = !this.eyeImg2Clicked;
    },

    togglePassword3View() {
      if (this.password3Type === "password") this.password3Type = "text";
      else this.password3Type = "password";

      this.eyeImg3Clicked = !this.eyeImg3Clicked;
    },

    async getUserData() {
      this.userDataChangedAlert = false;

      let data = {
        action: this.request.GetUser,
      };

      let getUserResponse = await makeRequest(data);
      switch (getUserResponse.data.error) {
        case RequestResult.OK: {
          this.phone = getUserResponse.data.data.phone;
          this.mobile = getUserResponse.data.data.phone_mobile;
          this.email = getUserResponse.data.data.email;
          this.user = getUserResponse.data.data.username;
          getUserResponse.data.data.zoneterms_agreement === 1
            ? this.agreements.push("service")
            : null;
          getUserResponse.data.data.newsletter === 1
            ? this.agreements.push("newsletter")
            : null;
          getUserResponse.data.data.phone_agreement === 1
            ? this.agreements.push("phone")
            : null;
          break;
        }
        case RequestResult.InvalidCookie:
        case RequestResult.CookieExpired:
        case RequestResult.GeneralError: {
          this.$router.push(this.routePath.Login);
          break;
        }
      }
    },

    onBackButtonClick() {
      this.$router.push(this.routePath.Home);
    },

    async onChangeDataButtonClick(event) {
      event.preventDefault();

      let necessaryDataValid =
        this.isEmailValid(this.email) &&
        this.isPhoneValid(this.phone) &&
        (this.mobile === null || this.mobile === "" || this.isPhoneValid(this.mobile)) &&
        this.agreements.includes("service");
      this.userDataChangedAlert = false;
      this.userDataNotChangedAlert = false;
      this.userPasswordChangedAlert = false;
      this.userPasswordNotChangedAlert = false;

      if (necessaryDataValid) {
        let data = {
          action: this.request.UpdateUserData,
          phone: this.phone.replace(/\s+/g, ""),
          mobile: this.mobile.replace(/\s+/g, ""),
          email: this.email,
          agreement_zoneterms: this.agreements.includes("service") ? 1 : 0,
          agreement_phone: this.agreements.includes("phone") ? 1 : 0,
          agreement_newsletter: this.agreements.includes("newsletter") ? 1 : 0,
        };

        let changeDataRequestResponse = await makeRequest(data);

        switch (changeDataRequestResponse.data.error) {
          case RequestResult.OK: {
            this.userDataChangedAlert = true;
            break;
          }
          case RequestResult.GeneralError: {
            this.userDataNotChangedAlert = true;
            break;
          }
          case RequestResult.InvalidCookie:
          case RequestResult.CookieExpired: {
            this.$router.push(this.routePath.Login);
            break;
          }
        }
      } else this.userDataNotChangedAlert = true;

      this.alertKey += 1;
    },

    async onChangePasswordButtonClick(event) {
      let necessaryDataValid =
          this.isPasswordValid(this.newPassword) &&
          this.isPasswordValid(this.newPasswordRepeat) &&
          (this.newPassword == this.newPasswordRepeat);

      this.userDataChangedAlert = false;
      this.userDataNotChangedAlert = false;
      this.userPasswordChangedAlert = false;
      this.userPasswordNotChangedAlert = false;

      if (necessaryDataValid) {
        event.preventDefault();

        let data = {
          action: this.request.UpdateUserPassword,
          usr: this.user,
          pass: this.oldPassword,
          newpass: this.newPassword,
        };

        let changePasswordRequestResponse = await makeRequest(data);

        switch (changePasswordRequestResponse.data.error) {
          case RequestResult.OK: {
            this.userPasswordChangedAlert = true;
            break;
          }
          case RequestResult.InvalidPassword:
          case RequestResult.InvalidOrMissingParameter:
          case RequestResult.GeneralError: {
            this.userPasswordNotChangedAlert = true;
            break;
          }
          case RequestResult.InvalidCookie:
          case RequestResult.CookieExpired: {
            this.$router.push(this.routePath.Login);
            break;
          }
        }
      } else {
        this.userPasswordNotChangedAlert = true;
      }

      this.alertKey += 1;
    },
  },
};
</script>

<style scoped>
.display-flex {
  /* do inputów z numerem telefonu - nadpisujemy display:block Bootstrapa */
  display: flex;
}
</style>
